import { render, staticRenderFns } from "./carouselImage.vue?vue&type=template&id=67de2dd4"
import script from "./carouselImage.vue?vue&type=script&lang=js"
export * from "./carouselImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports